import React from "react";

import CommonSection from "../components/UI/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import AboutSection from "../components/UI/AboutSection";
import { Container, Row, Col } from "reactstrap";
import driveImg from "../assets/all-images/drive.jpg";
// import OurMembers from "../components/UI/OurMembers";
import "../styles/about.css";

const About = () => {
  return (
    <Helmet title="About">
      <CommonSection title="About Us" />
      <AboutSection aboutClass="aboutPage" />

      <section className="about__page-section">
        <Container>
          <Row>
            <Col lg="6" md="6" sm="12">
              <div className="about__page-img">
                <img src={driveImg} alt="" className="w-100 rounded-3" />
              </div>
            </Col>

            <Col lg="6" md="6" sm="12">
              <div className="about__page-content">
                <h2 className="section__title">
                  We Are Committed To Provide Safe Ride Solutions
                </h2>

                <p className="section__description">
                  At Sankhu Car Rentals and Tours, we are dedicated to
                  delivering secure and reliable travel solutions tailored to
                  your needs. Our commitment to excellence ensures a seamless
                  and enjoyable journey for every adventure you embark on.
                </p>

                <p className="section__description">
                  Explore the comfort of our premium vehicles, accompanied by
                  professional drivers, guaranteeing a safe and pleasant ride.
                  Whether you're planning a city tour or a scenic escape, Sankhu
                  Car Rentals and Tours is here to make every moment of your
                  travel memorable.
                </p>

                <p className="section__description">
                  Your journey with Sankhu Car Rentals and Tours begins here -
                  where safety meets comfort, and every mile becomes a cherished
                  memory.
                </p>

                <div className=" d-flex align-items-center gap-3 mt-4">
                  <span className="fs-4">
                    <i class="ri-phone-line"></i>
                  </span>

                  <div>
                    <h6 className="section__subtitle">Need Any Help?</h6>
                    <h4>+254113474733</h4>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default About;
